// extracted by mini-css-extract-plugin
var _1 = "OnboardingNavBar-module__backButton--uJUHF";
var _2 = "OnboardingNavBar-module__backSpacer--YeqQe";
var _3 = "OnboardingNavBar-module__logo--wnx95";
var _4 = "OnboardingNavBar-module__logoLink--YNOuH";
var _5 = "OnboardingNavBar-module__nav--sh1T2";
var _6 = "OnboardingNavBar-module__progressBar--czUMX";
var _7 = "OnboardingNavBar-module__progressWrapper--vNZF2";
export { _1 as "backButton", _2 as "backSpacer", _3 as "logo", _4 as "logoLink", _5 as "nav", _6 as "progressBar", _7 as "progressWrapper" }
